import React, { Component } from "react";
import { fixTime, getDateString } from "../../helpers";
import { withRouter } from "react-router-dom";
// import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./Header.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import UserMenu from "./UserMenu";
import AppointmentDropdown from "./AppointmentDropdown";

const mapStateToProps = state => {
  return {
    menu: state.menu,
    // appointments: state.appointments.appointments
    InstructorID:
      state.appointments.appointments[
        Object.keys(state.appointments.appointments)[0]
      ]
  };
};

class Header extends Component {
  state = {
    isHiddenUser: true,
    isHiddenAppointment: true
  };

  title = () => {
    let path = this.props.location.pathname;
    let route = path.split("/");
    let { day, monthday } = getDateString(route[3]);
    if (route[3]) {
      let time = "";
      if (route[4]) {
        // This is a hack and needs to be fixed at some point. I am not proud of this...
        if (!Array.isArray(this.props.menu.menuItems)) {
          let index = this.props.menu.menuItems[route[3]].children.findIndex(
            appointment => appointment.id === route[4]
          );
          let apptTime = this.props.menu.menuItems[route[3]].children[index]
            .Time;
          time = ` - ${fixTime(apptTime)} Appointment`;
        }
      }

      return `${day} - ${monthday} ${time}`;
    }

    return route[2] ? route[2].replace("-", " ") : " ";
  };

  openDropdown = menuindex => {
    const newState = { ...this.state };
    newState[`isHidden${menuindex}`] = !this.state[`isHidden${menuindex}`];
    this.setState(newState);
  };
  render() {
    let id = Array.isArray(this.props.InstructorID)
      ? this.props.InstructorID[0].InstructorName
      : "";
    return (
      <header className="main-nav">
        <div className="nav-wrapper">
          <div
            className="nav-title"
            onClick={() => this.openDropdown("Appointment")}
          >
            <FontAwesomeIcon icon={faDesktop} />
            <h5>{this.title()}</h5>
            <FontAwesomeIcon icon={faCaretDown} />
            {!this.state.isHiddenAppointment && (
              <AppointmentDropdown
                items={this.props.menu.menuItems}
                location={this.props.location}
              />
            )}
          </div>
          <div
            onClick={() => this.openDropdown("User")}
            className="nav-dropdown"
          >
            <h5>{id.toLowerCase()}</h5> <FontAwesomeIcon icon={faCaretDown} />
            {!this.state.isHiddenUser && <UserMenu />}
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(Header)
);
